<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <app-jkedit  label="群組代號" #ME001Com  id="ME001"  [(value)]="item.ME001" [required]="true"  placeholder="群組代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <div class="jk-grid-cols-4">

    <app-jkedit  label="群組名稱" #ME002Com  id="ME002"  [(value)]="item.ME002" placeholder="群組名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="排序碼" #ME004Com  id="ME004"  [(value)]="item.ME004" placeholder="排序碼"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkcheckboxYN  label="更新碼" #ME005Com  id="ME005"  [(valueYN)]="item.ME005"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jknumberedit  label="平均漲幅" #ME006Com  id="ME006"  [(value)]="item.ME006" placeholder="平均漲幅"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jktextarea  height="250px"
 label="備註" #ME003Com  id="ME003"  [(value)]="item.ME003" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jknumberedit  label="前1/3漲跌幅%" #ME007Com  id="ME007"  [(value)]="item.ME007" placeholder="前1/3漲跌幅%"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="末1/3漲跌幅%" #ME008Com  id="ME008"  [(value)]="item.ME008" placeholder="末1/3漲跌幅%"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="最大漲幅%" #ME009Com  id="ME009"  [(value)]="item.ME009" placeholder="最大漲幅%"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jktext  label="更新時間" [value]="item.ME010"     >
    </app-jktext>
    <app-jknumberedit  label="趨勢" #ME011Com  id="ME011"  [(value)]="item.ME011" placeholder="趨勢"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="漲幅超過N%通知" #ME012Com  id="ME012"  [(value)]="item.ME012" placeholder="漲幅超過N%通知"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkcheckboxYN  label="熱力圖分析" #ME013Com  id="ME013"  [(valueYN)]="item.ME013"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="條件代號" #ME014Com  id="ME014"  [(value)]="item.ME014" placeholder="條件代號"  [readonly]="isBrowse"     >
    </app-jkedit>

    </div>
  </div>
</div>
